const isJupyterDisabled = () => {
  return global.JUPYTER_DISABLED === 'true';
};

export default isJupyterDisabled;
